var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 3.54167L11.3421 4.65792L13.3846 6.70833H5.33331V8.29167H13.3846L11.3421 10.3342L12.4583 11.4583L16.4166 7.5L12.4583 3.54167ZM2.16665 1.95833H8.49998V0.375H2.16665C1.29581 0.375 0.583313 1.0875 0.583313 1.95833V13.0417C0.583313 13.9125 1.29581 14.625 2.16665 14.625H8.49998V13.0417H2.16665V1.95833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.af087ec7.svg";
export { ForwardRef as ReactComponent };